import {
  _createTip,
  _validateFail,
  _validateSuccess
} from './_mapping-helper'

export const SHOW_IN = {
  CENTER: 'center',
  CREATE: 'create',
  MODIFY: 'modify',
  CURRENT: 'current',
  NO_CENTER: '-center',
  NO_CREATE: '-create',
  NO_MODIFY: '-modify',
  NO_CURRENT: '-current'
}

export const TYPE = {
  LIST: 'list',
  LABEL: 'label',
  DATE_RANGE: 'date-range',
  SELECTOR: 'selector',
  ICON_UPLOAD: 'icon-upload',
  REMOTE_FETCH: 'remote-fetch',
  TEXT_AREA: 'textarea',
  DATE: 'date',
  DATE_YMD: 'date-ymd',
  RENDER: 'render',
  RENDER_LABEL_AND_CONTENT: 'renderLabelAndContent'
}

export const ROUTE_NAME_OF_DI_PAGE = {
  CENTER: 'diDingCenter',
  CREATE: 'diDingCreate'
}

export const DI_NAME_IN_PARAMS = 'diName'

export {
  _registerConfig as registerConfig
} from './_content-maps'

export {
  _registerNav as registerNav
} from './_nav-maps'

export const mappingHelper = {
  createTip: _createTip,
  validateSuccess: _validateSuccess,
  validateFail: _validateFail
}



// WEBPACK FOOTER //
// ./src/components/common/di-ding/index.js